import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container flex flex-col gap-8 py-4 md:flex-row md:py-10 lg:gap-18',
    suggestions: 'flex w-full flex-1 flex-col gap-8 md:gap-6',
    products: 'w-full md:w-[400px] lg:w-[780px]',
    productList: 'flex flex-wrap gap-x-2 gap-y-10 py-4',
    productItem: 'w-[calc(50%-8px)] md:w-[250px]'
  }
});
